/* ==========================================================================
   KINOVA — 21-bosqich: video ostidagi harakatlar paneli

   Bu fayl FAQAT YANGI narsalarni boshqaradi:
     • "Yoqdi" (like) — bir akkaunt uchun bir marta, server tasdiqlaydi;
     • "Ulashish" oynasi (bottom sheet) — ochish/yopish/nusxalash;
     • "Sevimlilar" tugmasi (pleer sahifasidagi nusxasi).

   Baho (yulduzcha) va izohlar mantig'i ATAYLAB bu yerda QAYTA
   YOZILMAGAN — u `film-detail.js` da allaqachon bor va sinovdan
   o'tgan. Panel o'sha JS kutgan identifikatorlarni saqlaydi.
   ========================================================================== */
(function (global) {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function csrf() {
    return global.KINOVA_CSRF_TOKEN
      || (document.querySelector('meta[name="csrf-token"]') || {}).content
      || '';
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': csrf(),
      },
      body: JSON.stringify(body || {}),
    }).then(function (r) {
      return r.json().catch(function () { return {}; })
        .then(function (b) { return { status: r.status, body: b }; });
    });
  }

  var Icon = global.Icon || {};
  function ic(name, size) { return (Icon[name] || Icon.tag || function () { return ''; })(size); }

  /* 23-bosqich: xato endi JIMGINA yutilmaydi. Ilgari 404/419/500 javoblar
     e'tiborsiz qoldirilardi va foydalanuvchiga tugma "ishlamayotgandek"
     tuyulardi (aynan shu "like bosib bo'lmayapti" shikoyatiga sabab bo'lgan). */
  function say(message, tone) {
    var KC = global.KC;
    if (KC && typeof KC.toast === 'function') { KC.toast(message, tone); return; }
    /* KC yuklanmagan bo'lsa ham xabar yo'qolmasin. */
    if (tone === 'error' && global.console && console.warn) console.warn('[KINOVA] ' + message);
  }

  function failMessage(status) {
    if (status === 401 || status === 419) return 'Sessiya tugagan — sahifani yangilang va qayta kiring.';
    if (status === 403) return 'Bu amal uchun ruxsat yo\'q.';
    if (status === 429) return 'Juda tez bosildi — bir oz kuting.';

    return 'Xatolik yuz berdi, qaytadan urinib ko\'ring.';
  }

  /* ══ 1) "YOQDI" ═══════════════════════════════════════════════════ */
  function wireLike(root) {
    var btn = document.getElementById('watchLike');
    if (!btn) return;

    var countEl = document.getElementById('watchLikeCount');
    var url = root.getAttribute('data-like-url') || '';
    var authed = root.getAttribute('data-authed') === '1';
    var loginUrl = root.getAttribute('data-login-url') || '/login';
    var busy = false;

    btn.addEventListener('click', function () {
      /* ⚠️ Mehmonga SOXTA holat ko'rsatilmaydi: tugma "bosilgan"
         ko'rinishga o'tmaydi, balki kirish sahifasiga olib boradi. */
      if (!authed) { global.location.href = loginUrl; return; }
      if (busy || !url) return;
      busy = true;

      post(url).then(function (res) {
        busy = false;

        if (res.status !== 200 || !res.body || res.body.ok !== true) {
          say(failMessage(res.status), 'error');

          return;
        }

        var liked = res.body.liked === true;
        btn.classList.toggle('is-on', liked);
        btn.setAttribute('aria-pressed', liked ? 'true' : 'false');

        // Raqam SERVERDAN keladi — ekranda taxminiy son turmasin.
        if (countEl && typeof res.body.likes === 'number') {
          countEl.textContent = res.body.likes;
        }

        var svg = btn.querySelector('svg');
        var next = liked ? ic('heartFilled', 18) : ic('heart', 18);
        if (svg && next) svg.outerHTML = next;

        btn.classList.remove('is-pop');
        void btn.offsetWidth; // animatsiyani qayta boshlash
        btn.classList.add('is-pop');
      }).catch(function () {
        busy = false;
        say('Internet aloqasi uzildi.', 'error');
      });
    });
  }

  /* ══ 2) ULASHISH OYNASI ═══════════════════════════════════════════ */
  function wireShareSheet() {
    var sheet = document.getElementById('shareSheet');
    var bg = document.getElementById('shareSheetBg');
    var openBtn = document.getElementById('watchShare');
    if (!sheet || !bg || !openBtn) return;

    var closeBtn = document.getElementById('shareSheetClose');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      bg.hidden = false; sheet.hidden = false;
      // Brauzer `hidden` olib tashlanishini ko'rib ulgursin —
      // aks holda ochilish animatsiyasi ishlamaydi.
      requestAnimationFrame(function () {
        bg.classList.add('is-open');
        sheet.classList.add('is-open');
      });
      document.addEventListener('keydown', onKey);
    }

    function close() {
      bg.classList.remove('is-open');
      sheet.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { bg.hidden = true; sheet.hidden = true; }, 300);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onKey(e) { if (e.key === 'Escape') close(); }

    openBtn.addEventListener('click', open);
    bg.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Havolani bosgach oyna yopilsin (yangi varaqda ochiladi).
    sheet.querySelectorAll('a.sh').forEach(function (a) {
      a.addEventListener('click', function () { setTimeout(close, 150); });
    });

    /* "Nusxalash" — `film-detail.js` dagi `[data-share-copy]` mantig'i
       `.share-row` uchun yozilgan. Bu yerda oynaning O'ZI yopilishi ham
       kerak, shuning uchun alohida tinglovchi. */
    var copy = sheet.querySelector('[data-share-copy]');
    if (copy) {
      copy.addEventListener('click', function () {
        var url = sheet.getAttribute('data-share-url') || global.location.href;
        var done = function () {
          var label = copy.lastChild;
          if (label && label.nodeType === 3) {
            label.nodeValue = 'Nusxalandi';
            setTimeout(function () { label.nodeValue = 'Nusxalash'; }, 1600);
          }
          setTimeout(close, 700);
        };

        if (global.navigator && navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(done);
        } else {
          // Eski brauzerlar uchun zaxira yo'l.
          var ta = document.createElement('textarea');
          ta.value = url; ta.setAttribute('readonly', '');
          ta.style.position = 'fixed'; ta.style.left = '-9999px';
          document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (e) { /* e'tiborsiz */ }
          document.body.removeChild(ta);
          done();
        }
      });
    }
  }

  /* ══ 3) SEVIMLILAR (pleer sahifasidagi nusxasi) ═══════════════════ */
  function wireFav(root) {
    var btn = document.getElementById('watchFav');
    if (!btn) return;

    var authed = root.getAttribute('data-authed') === '1';
    var loginUrl = root.getAttribute('data-login-url') || '/login';
    /* 23-bosqich — JIDDIY XATO TUZATILDI (foydalanuvchi bildirgan:
       "sevimlilarga bossa sevimlilar menyusida hech narsa yo'q").

       Ilgari bu yerda `data-content-id` (RAQAM) o'qilardi va so'rov
       `/favorites/42` ga ketardi. Lekin marshrut `{content}` ni SLUG
       bo'yicha bog'laydi (HasSlug::getRouteKeyName), shuning uchun
       Laravel 404 qaytarardi va quyidagi `ok !== true` sharti uni
       JIMGINA tashlab yuborardi — tugma bosilardi, lekin bazaga HECH
       NARSA yozilmasdi, shuning uchun profildagi "Sevimlilar" bo'limi
       doim bo'sh qolardi. Kino sahifasidagi (details.js) nusxasi slug
       ishlatgani uchun u YERDA ishlab turardi — shuning uchun xato
       darhol ko'zga tashlanmagan. */
    var id = btn.getAttribute('data-slug') || root.getAttribute('data-slug');
    var busy = false;

    btn.addEventListener('click', function () {
      if (!authed) { global.location.href = loginUrl; return; }
      if (busy || !id) return;
      busy = true;

      var on = btn.classList.contains('is-on');
      fetch('/favorites/' + encodeURIComponent(id), {
        method: on ? 'DELETE' : 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': csrf(),
        },
      }).then(function (r) {
        return r.json().catch(function () { return {}; })
          .then(function (b) { return { status: r.status, body: b }; });
      })
        .then(function (res) {
          busy = false;
          var b = res.body;

          if (res.status !== 200 || !b || b.ok !== true) {
            say(failMessage(res.status), 'error');

            return;
          }

          var fav = b.is_favorited === true;
          btn.classList.toggle('is-on', fav);
          btn.setAttribute('aria-pressed', fav ? 'true' : 'false');

          var svg = btn.querySelector('svg');
          var next = fav ? ic('check', 17) : ic('plus', 17);
          if (svg && next) svg.outerHTML = next;

          /* Yorliq ham holatni aytadi — faqat rang bilan cheklanmaymiz. */
          var label = btn.querySelector('.watch-btn__t');
          if (label) label.textContent = fav ? 'Saqlandi' : 'Sevimlilar';

          btn.classList.remove('is-pop');
          void btn.offsetWidth;
          btn.classList.add('is-pop');

          say(fav ? 'Sevimlilarga qo\'shildi' : 'Sevimlilardan olib tashlandi');
        }).catch(function () {
          busy = false;
          say('Internet aloqasi uzildi.', 'error');
        });
    });
  }

  ready(function () {
    var root = document.getElementById('watchActions');
    if (!root) return;
    wireLike(root);
    wireShareSheet();
    wireFav(root);
  });
})(window);
